import moon404 from "../../../assets/404moon.gif"
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0a0a23] text-white flex flex-col justify-center items-center p-6 font-['SF Pro Display',sans-serif]">
      <div className="flex flex-col lg:flex-row items-center justify-center gap-10 text-center lg:text-left">
        
        <img 
          src={moon404} 
          alt="404 astronaut" 
          className="w-65 h-60 lg:w-[500px] lg:h-[450px] object-contain drop-shadow-[0_4px_20px_rgba(255,255,255,0.2)] transition-all duration-500" 
        />

        \
        <div className="space-y-4 max-w-md">
          <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight">
            Oops!
             {/* <span className="block text-2xl font-light text-gray-400">Looks like you're lost in space.</span> */}
          </h1>

          <p className="text-lg text-gray-300">
            The page you’re looking for doesn’t exist or has been moved.
          </p>

          <Link
            to="/"
            className="inline-block px-6 py-3 mt-2 bg-white text-[#0a0a23] rounded-full font-semibold shadow-md transition-all hover:bg-gray-200"
          >
            Go back home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

